// extracted by mini-css-extract-plugin
export default {"page":"g1-z","cartModal":"h1-z","checkout":"i1-z","placeholder":"j1-z","account":"k1-z"};